import StackedArray from '@/utils/StackedArray';

const trimTrailingSlash = (url: string) => (typeof url === 'string' ? url.replace(/\/$/, '') : url);

const oldapp = {
    baseURL: 'https://is.voicecasting.sk',
};

const auth = {
    server: 'https://auth.voicecasting.sk',
    client_id: '013dd9c6-3cac-43b2-a118-ba93285abaa2', //vc.app
    redirect_uri: '/authorize',
};

const bugsnag = {
    apiKey: process.env.MIX_BUGSNAG_API_KEY,
};

export default StackedArray.get(process.env.NODE_ENV, [
    [
        'development',
        {
            local: {
                baseURL: `${trimTrailingSlash(process.env.MIX_SERVICE_LOCAL_API_URL) || ''}/api`,
            },
            admin: {
                baseURL: `${trimTrailingSlash(process.env.MIX_SERVICE_ADMIN_URL) || ''}/api/admin`,
            },
            storage: {
                baseURL: process.env.MIX_SERVICE_STORAGE_URL,
            },
            oldapi: {
                baseURL: process.env.MIX_SERVICE_OLD_API_URL,
            },
            oldapp,
            auth,
            bugsnag,
        },
    ],
    [
        'production',
        {
            local: {
                baseURL: '/api',
            },
            admin: {
                baseURL: '/api/admin',
            },
            storage: {
                baseURL: 'https://files.voicecasting.sk',
            },
            oldapi: {
                baseURL: 'https://storage.voicecasting.sk/api',
            },
            oldapp,
            auth,
            bugsnag,
        },
    ],
]);
